import apiConfig from './api'

export default {
  getTable: (tableName: string) => `${apiConfig.apiEndpoint}/api/${apiConfig.space}/database/${tableName}/row`,
  getLandingDetail: () => `${apiConfig.apiEndpoint}/api/${apiConfig.space}/content-hub/landing.json`
}
